/** @jsxImportSource @emotion/react */

import styled from "@emotion/styled";
import React, { useEffect, useState } from "react";

import DeleteForeverIcon from "@material-ui/icons/DeleteForever";

import { useStoreon } from "storeon/react";
import Button from "@material-ui/core/Button";
import Input from "@material-ui/core/Input";
import Slider from "@material-ui/core/Slider";

import confirm from "components/Dialog";
import t from "translations";

import Collages from "comp/collage/Collages";
import { Typography } from "@material-ui/core";

const SaveWrap = styled.div`
  display: flex;
  margin: 10px 0;
  align-items: center;
  justify-content: space-between;
`;

const PaddingWrap = styled.div`
  margin: 10px 8px;
  display: flex;
  flex-direction: row;
  > div {
    flex-basis: 50px;
    margin-left: 10px;
    > input {
      text-align: center;
    }
  }
`;

const CollagesList = () => {
  const {
    dispatch,
    id,
    isAdmin,
    collages,
    isCollagesLoading,
    editorType,
    canvas
  } = useStoreon(
    "id",
    "isAdmin",
    "collages",
    "isCollagesLoading",
    "canvas",
    "editorType"
  );
  const [title, setTitle] = useState("");
  const [padding, setPadding] = useState(0);

  useEffect(() => {
    dispatch("collage/get");
  }, [dispatch]);

  useEffect(() => {
    const activeCollage = collages.find(collage => collage.id === id);
    if (activeCollage && activeCollage.title) {
      setTitle(activeCollage.title);
    }
  }, [collages, id]);

  const handleNew = () => dispatch("collage/create");

  const handleSave = () => dispatch("collage/save", title);

  const handleDeleting = async id => {
    const result = await confirm.show({
      icon: <DeleteForeverIcon style={{ marginRight: 10 }} />,
      title: t.removeEditor
    });
    if (!result) {
      return;
    }
    dispatch("collage/delete", id);
  };
  const handleSelection = collage => dispatch("collage/select", collage);

  const updateCollagePadding = val => {
    canvas
      .getObjects()
      .filter(o => o.excludeFromExport === false)
      .filter(o => o.mask)
      .forEach(function(obj) {
        const oldSnap = obj.snap ? obj.snap : 0;
        const diff = val - oldSnap;
        if (diff === 0) {
          return;
        }
        const width = obj.width * obj.scaleX;
        const height = obj.height * obj.scaleY;
        const center = obj.getCenterPoint();
        obj.snap = val;
        const scaleX = (width - diff * 2) / obj.width;
        const scaleY = (height - diff * 2) / obj.height;
        obj.set({ scaleX, scaleY });
        obj.setPositionByOrigin(center, "center", "center");
        obj.setCoords();
        /* obj.scaleToHeight(height + diff); */
      });
    canvas.padding = val;
    canvas.renderAll();
  };

  return (
    <React.Fragment>
      {editorType === "collage" && (
        <>
          <Typography style={{color:'white'}}>{t.collagePadding}</Typography>
          <PaddingWrap>
            <Slider
              onChange={(e, val) => {
                setPadding(val);
                updateCollagePadding(val);
              }}
              min={0}
              max={30}
              step={1}
              value={padding}
            />
            <Input
              fullWidth
              value={padding}
              onChange={e => {
                let val = parseInt(e.target.value, 10);
                if (val < 0 || isNaN(val)) {
                  val = 0;
                }
                if (val > 30) {
                  val = 30;
                }
                updateCollagePadding(val);
                setPadding(val);
              }}
            />
          </PaddingWrap>
        </>
      )}
      {isAdmin && (
        <React.Fragment>
          <Button
            style={{ marginTop: 10 }}
            disabled={isCollagesLoading}
            onClick={handleNew}
            variant="contained"
            fullWidth
          >
            New
          </Button>
          <SaveWrap>
            <Input
              disabled={!id || isCollagesLoading}
              placeholder="Collage name"
              value={title}
              onChange={e => setTitle(e.target.value)}
              inputProps={{ style: { paddingLeft: 10 } }}
            />
            <Button
              disabled={!id || isCollagesLoading}
              onClick={handleSave}
              color="secondary"
              variant="contained"
            >
              Save
            </Button>
          </SaveWrap>
        </React.Fragment>
      )}
      <Collages
        isAdmin={isAdmin}
        selected={id}
        collages={collages}
        isLoading={isCollagesLoading}
        onSelect={handleSelection}
        onRemove={handleDeleting}
      />
    </React.Fragment>
  );
};

export default CollagesList;
